module.exports = __webpack_public_path__ + "img/save-white.fbc18652.svg";